<template>
  <div id="ehallCardTimeoutMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>复旦月卡管理</el-breadcrumb-item>
          <el-breadcrumb-item>外协车超时停放车辆管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-row>
          <el-col :span="22">
            <el-form-item label="开始时间::">
          <el-date-picker v-model="startTime"
                          style="width:200px"
                          type="datetime"
                          :clearable="false"
                          format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间::">
          <el-date-picker v-model="endTime"
                          style="width:200px"
                          :clearable="false"
                          format="yyyy-MM-dd HH:mm:ss"
                          type="datetime"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
            <el-form-item label="车牌::">
              <el-input placeholder="请输入车牌号码"
                        v-model="fPlateCode">
              </el-input>
            </el-form-item>
            <el-form-item label="处理状态">
              <el-select v-model="IsHandle"
                     placeholder="请选择处理状态"
                     filterable>
            <el-option v-for="item in vehicleTypes"
                       :key="item.value"
                           :label="item.label"
                           :value="item.value">
            </el-option>
          </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
              <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="false"
                     @click="exportData">{{export_msg}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="chnlList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                :row-class-name="tableRowClassName"
                ref="singleTable">
        <el-table-column type="index"
                          width="50"
                          :index="indexMethod"
                          label="序号">
        </el-table-column>
        <el-table-column prop="feHallID"
                          width="150"
                          v-if="true"
                          label="违章流水">
        </el-table-column>
        <el-table-column prop="RowId"
                          width="150"
                          label="违章流水">
        </el-table-column>
        <el-table-column prop="TableType"
                          width="90px"
                          label="类型">
        </el-table-column>
        <el-table-column prop="PlateNo"
                          width="105"
                          label="车牌号码">
        </el-table-column>
        <el-table-column prop="fCardPhone"
                          width="105"
                          label="手机号码">
        </el-table-column>
        <el-table-column prop="AlarmTime"
                          width="160px"
                          label="违章日期">
        </el-table-column>
        <el-table-column prop="InTime"
                          width="160px"
                          label="入场日期">
        </el-table-column>
        <el-table-column prop="fBuildName"
                          width="90px"
                          label="楼幢名称">
        </el-table-column>
        <el-table-column prop="VehicleStatus_ZN"
                          width="90px"
                          label="违章类型">
        </el-table-column>
        <el-table-column prop="Address"
                          label="违章地点">
        </el-table-column>
        <el-table-column label="违章图片" align="center" width="150" height:50px>
            <template slot-scope="scope">
            <el-image class="image"
                        :src="scope.row.PlateNoImage"
                        :preview-src-list="[scope.row.PlateNoImage]">
                  <template #error>
                    <div class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                </template>
            </el-image>
            </template>
          </el-table-column>
              <el-table-column fixed="right"
                          label="操作"
                          align="center"
                          width="180">
          <template slot-scope="scope">
            <el-button @click="sendSMSChnlClient(scope.$index, scope.row)"
                        type="warning"
                        v-if="is_sendSMS && scope.row.fCardPhone!=='' && scope.row.fCardPhone!==undefined"
                        size="mini">发生短信</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="false">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ehallCardTimeoutMain.vue',
  data () {
    return {
      loading: false,
      is_export: false,
      is_sendSMS: false,
      export_msg: '导出',
      export_loading: false,
      save_msg: '保存',
      save_loading: false,
      selCustID: '',
      choiceCusts: [],
      curRowInfo: {
        fBigRowID: 0,
        isEdit: false,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fFloorName: '',
        fAreaName: '',
        fPlaceNo: '',
        fDeviceID: '',
        fThiPubUrl: '',
        fThiToken: '',
        fRemark: ''
      },
      chnlEditOrDetailVisible: false,
      detailTitle: '查看相机信息',
      choiceParks: [],
      parks: [],
      selfParkID: '',
      fPlateCode: '',
      chnlList: [],
      tableHeight: 200,
      form: {

      },
      IsHandle: 0,
      startTime: '',
      endTime: '',
      fstartTime: '',
      fendTime: '',
      pageSize: 20,
      pageNo: 1,
      total: 0,
      errorChecked: true,
      vehicleTypes: [{ value: 0, label: '待处理' }, { value: 1, label: '已处理' }]
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    ...mapActions([
      'getParkList', 'getEhallCardTimeoutQuery', 'parkGeoDataUpload', 'importParkGeoData', 'parkGeoDataTemplate', 'getChannelParamById', 'getCustByGroup', 'saveParkGeomagnetic', 'sendSMS', 'ascParkLock', 'descParkLock', 'descOrAecParkLock', 'getParkLockStatus', 'synChnlById', 'getCurrentUserPers'
    ]),
    tableRowClassName ({ row, rowIndex }) {
      if (row.isRed === true) {
        return 'warning-row'
      }
      return ''
    },
    exportData () {
      // if ((this.selCustID || '').trim().length <= 0) {
      //   this.$message.error('提示：请先选择客户')
      //   return false
      // }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      let chnlParam = {}
      chnlParam['fParkID'] = this.selfParkID
      chnlParam['fCustID'] = this.selCustID
      chnlParam['fPlateCode'] = this.fPlateCode
      chnlParam['errorChecked'] = this.errorChecked
      this.fstartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.fendTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      chnlParam.fstartTime = this.fstartTime
      chnlParam.fendTime = this.fendTime
      chnlParam.IsHandle = this.IsHandle
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.exportData = 1
      this.getParkDevCamQuery(chnlParam).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_场库车位相机数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    bindQuery () {
      this.initData()
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      let chnlParam = {}
      chnlParam['fParkID'] = this.selfParkID
      chnlParam['fCustID'] = this.selCustID
      chnlParam['fPlateCode'] = this.fPlateCode
      chnlParam['errorChecked'] = this.errorChecked
      if ((this.startTime || '').toString().trim().length > 0) {
        this.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.fendTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      chnlParam.fstartTime = this.fstartTime
      chnlParam.fendTime = this.fendTime
      chnlParam.IsHandle = this.IsHandle
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.exportData = 0
      this.loading = true
      this.getEhallCardTimeoutQuery(chnlParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // let tmpChnl = []
              // Object.assign(tmpChnl, data.Data.rows)
              this.chnlList = data.Data.rows || []
              // this.total = data.Data.total
            }
          }
        }
      })
    },
    sendSMSChnlClient (index, row) {
      this.$confirm('发送短信通知车主, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sendSMS(row).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    viewChannel (row) {
      setTimeout(() => {
        if (this.$refs['parkLockForm']) {
          this.$refs['parkLockForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '查看相机【' + row.fCamIPAddr + '】'
      this.chnlEditOrDetailVisible = true
      this.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data
            }
          }
        }
      })
      this.curRowInfo = {}
      this.curRowInfo = row
      this.curRowInfo.isEdit = false
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
    },
    setPark (val, type, fParkID = '') {
      if (type === 0) {
        this.choiceParks = []
        this.selfParkID = ''
      } else if (type === 1) {
        this.parks = []
        if ((fParkID || '').trim().length <= 0) {
          this.curRowInfo.fParkID = ''
        }
      }
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (type === 0) {
                this.choiceParks = data.Data || []
              } else if (type === 1) {
                this.parks = data.Data || []
              }
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 26700 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
            this.is_sendSMS = data.Data.data.is_sendSMS
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.init()
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.setPark(this.selCustID, 0)
            }
          }
        }
      }
    })
    // this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
/* #ehallCardTimeoutMain .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
} */
/* .myChnlEditOrDetail .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 13px;
} */
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.myChnlEditOrDetail
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.myChnlEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.myChnlEditOrDetail .el-dialog__title {
  color: white;
}
.myChnlEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myChnlEditOrDetail .el-dialog__body {
  padding: 5px;
  padding-bottom: 0px;
}
.myChnlEditOrDetail .ledDialog .el-dialog__body {
  padding: 0px;
}
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666666;
  cursor: not-allowed;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .myChnlLableClass {
  text-align: right;
  float: left;
  color: #606266;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .is-disabled .el-input__inner,
.myChnlEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}
.myChnlEditOrDetail .el-row {
  margin-bottom: 5px;
}
.myChnlEditOrDetail .el-radio {
  line-height: 2px;
}
/* dialog弹出框样式 */
#ehallCardTimeoutMain .channelDialog .el-dialog {
  min-width: 910px;
}
#ehallCardTimeoutMain .screenDialog .el-dialog {
  min-width: 800px;
}
#ehallCardTimeoutMain .voiceDialog .el-dialog {
  min-width: 410px;
}
#ehallCardTimeoutMain .warning-row {
  color: chocolate;
}
#ehallCardTimeoutMain .error-row {
  color: #fb4545;
}
</style>

<style scoped>
fieldset {
  padding-bottom: 0px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.searchRowAdd {
  text-align: right;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/park/ehallCardTimeoutMain.vue